export default "__VITE_ASSET__DN7n5Za0__"